/**
 * The easing curves the app animates on.
 *
 * CSS gets these as `--ease-out` / `--ease-in-out` in index.css, and Tailwind's
 * `ease-out` and `ease-in-out` utilities are re-pointed at them. This module is
 * the same two curves for framer, which wants control points rather than a CSS
 * string. Both halves have to agree or a component animated in JS drifts away
 * from the one beside it animated in CSS.
 *
 * They are stronger than the browser defaults on purpose. `ease-out` at
 * cubic-bezier(0, 0, 0.2, 1) is gentle enough that a 200ms transition reads as
 * a slow fade rather than a decision; the steeper front end is what makes a
 * control feel like it answered.
 */

/** Entrances, exits, and anything the user just asked for. */
export const EASE_OUT = [0.23, 1, 0.32, 1];

/** Movement between two on-screen positions, where both ends need settling. */
export const EASE_IN_OUT = [0.77, 0, 0.175, 1];
